<template>
  <div class="refundability" :key="refundable.text">
    <vb-icon class="refundability__icon" :name="refundable.icon" :color="sass(refundable.variant)" :size="14" />
    <span :class="'refundability__text refundability__text--' + refundable.variant">{{ refundable.text }}</span>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'refundability',

  components: {
  },

  props: {
    cancellation: Object,
  },

  data() {
    return {
    }
  },

  computed: {

    refundable() {
      const cancellation = this.cancellation.free_cancellation_until,
            formatted_date = cancellation
              ? moment(cancellation, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY') //2026-01-21T22:59:59+00:00
              : ''

      return {
        text: cancellation
          ? `Cancellazione gratuita fino al ${formatted_date}`
          : 'Non rimborsabile',
        icon: this.cancellation.refundability.refundable_before ? 'check-circle' : 'lock_v2',
        variant: this.cancellation.refundability.refundable_before ? 'success' : 'gray-600',
      }
    }

  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .refundability {
    line-height: normal;
    display: flex;
    align-items: center;
    font-size: $font-size-md;

    &__text {
      font-weight: $vb-font-weight-semibold;

      &--success {
        color: $success;
      }
    }

    &__icon {
      display: none;

      @include media-breakpoint-up(sm){
        display: block;
        margin-right: 5px;
      }

      &--info {
        margin: 2px 0 0 5px;
      }
    }
  }

</style>